import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import IconCard1 from "../../images/icon_card_20.png";
import IconCard2 from "../../images/icon_card_3.png";
import IconCard3 from "../../images/icon_card_19.png";
import IconCard4 from "../../images/icon_card_14.png";
import imageEcom from "../../images/img_ecom.png";
import RoyaleSpacesLogo from "../../images/RoyaleSpacesLogo";

const ProjectPage = () => {
  const solutions = [
    {
      title: "Struggle in Patient Engagement & Appointment Bookings?",
      problem:
        "Complex appointment schteduling, lack of patient communication, & high no-show rates.",
      solution:
        "We build user-friendly, automated booking systems with reminders, chatbots, and patient portals to streamline interactions and reduce missed appointments.",
    },
    {
      title: "Need a Secure & HIPAA-Compliant Digital Presence?",
      problem:
        "Data security concerns, regulatory compliance issues, and outdated systems.",
      solution:
        "We develop HIPAA-compliant, secure websites with encrypted data management, role-based access, and telemedicine integrations.",
    },
    {
      title: "Limited Online Visibility & Patient Acquisition?",
      problem:
        "Low search engine rankings, ineffective social media marketing, & limitless patient outreach.",
      solution:
        "We implement SEO strategies, paid ad campaigns, and local search optimization to enhance online visibility and attract more patients.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "Property listing platforms with advanced search filters",
        "Real estate CRM integration for lead tracking",
        "Virtual tour & video walkthrough implementation",
        "Mortgage & affordability calculators",
        "IDX/MLS integration for seamless property updates",
      ],
      image: require("../../images/web-development.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "Local SEO to rank higher in property searches",
        "Paid Ads for instant lead generation",
        "Email marketing campaigns to nurture prospects",
        "Social media marketing & influencer partnerships",
        "Reputation management & brand storytelling",
      ],
      image: require("../../images/digital-marketing.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    {
      title: "Property Listing UI Mockups",
      icon: IconCard1,
    },
    {
      title: "Real Estate Analytics Charts",
      icon: IconCard2,
    },
    {
      title: "PPC Campaign Performance Infographics",
      icon: IconCard3,
    },
    {
      title: "Engaging Website & Mobile Designs",
      icon: IconCard4,
    },
  ];

  // const caseStudyData = {
  //   sectionTitle: "Real Results for Real Estate Businesses",
  //   sectionSubtitle:
  //     "Our custom-built property listing website increased organic leads by 60% in just 6 months!",
  //   image: require("../../images/cart/cart.png"),
  //   imageAlt: "E-commerce Case Study",
  //   title: "Establishment of an Ecom",
  //   description:
  //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
  //   buttonText: "Read More",
  //   viewMoreText: "View More Case Studies ➜",
  // };
  const caseStudyData = {
    sectionTitle: "Royale Spaces – Your Trusted Estate Agency Partner",
    sectionSubtitle: "Delivering exceptional property solutions across the UK.",
    image: <RoyaleSpacesLogo width="100%" style={{ maxHeight: 180 }} />, // Use SVG as React element
    imageAlt: "Royale Spaces",
    title: "Experience Royal Service in Real Estate",
    description:
      "Royale Spaces is your trusted partner in estate agency management. Based in the West Midlands, we deliver exceptional service for buying, selling, renting, and managing properties. Our team is committed to integrity, innovation, and customer-centricity, making your property journey seamless and successful.",
    buttonText: "Visit Royale Spaces",
    viewMoreText: "View More Case Studies ➜", // (optional, can be omitted)
  };

  const realEstateData = {
    title: "Let’s Elevate Your Real Estate Business",
    description:
      "Ready to take your real estate business to the next level? Our expert digital solutions help you attract more buyers, generate high-quality leads, and enhance your online presence. Let’s build a strategy tailored to your success!",
    buttonText: "Contact Us",
    image: require("../../images/real-estate.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];
  const header =
    "Stay updated with the latest trends, strategies, and insights in real estate digital transformation.Explore our expert blog posts:";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={
            "Powering Real Estate Businesses with Smart Digital Solutions"
          }
          pageSub={
            "From high-converting property websites to data-driven digital marketing, we help real estate businesses generate more leads and close deals faster."
          }
          backgroundImage={require("../../images/web-2.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        <CaseStudyCard caseStudy={caseStudyData} />
        <SoftwareFeatures
          features={features}
          title={"Craft Your Web-Based Software"}
          subTiltle={"When you team up with us for web development, you get"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="flex-start"
          boxAlign="flex-end"
          justifyContent="flex-end"
          textAlign="right"
          titleColor="#000"
          descriptionColor="#000"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPage;
